import axios from 'axios';
import { getToken, getTokenCookie } from './auth';
export default function configureApiRestService() {
   axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
   axios.defaults.headers.common['Content-Type'] = 'application/json';
   axios.defaults.headers.common['Accept'] = 'application/json';
   if (getToken() !== null) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + getToken();
   } else if (getTokenCookie() !== null) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + getTokenCookie();
   }

   axios.interceptors.response.use(function (response) {
      return response;
   }, function (error) {
      if (error.response.status === 401) {
         alert("Sesión caducada, por favor vuelva a ingresar");
         window.location.href = process.env.REACT_APP_BASE_URL as string;
      }
      else {
         return Promise.reject(error);
      }
   });

}


